import React from 'react';
import ContractFormService from '../services/ContractFormService';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import ContractForm from './ContractForm';
import { BRAZIL } from '../../../core/consts';

class ContractFormContainer extends React.Component {
  static propTypes = {
    contractId: PropTypes.string,
  };

  async componentDidMount() {
    ContractFormService.init();
    if (this.props.contractId) {
      await ContractFormService.load(this.props.contractId);
    }
  }

  handleReset() {
    ContractFormService.form.reset();
    ContractFormService.productsService.form.reset();
  }

  render() {
    return (
      <ContractForm
        onSubmit={ContractFormService.handleSubmit}
        onReset={this.handleReset}
        values={ContractFormService.form.getValues()}
        disabled={ContractFormService.submit.fetching || ContractFormService.fetch.fetching}
        loading={ContractFormService.fetch.fetching}
        onChange={ContractFormService.onChange}
        submitting={ContractFormService.submit.fetching}
        errors={ContractFormService.form.errors}
        onAddProduct={ContractFormService.productsService.handleToggleModal}
        currencyType={
          !ContractFormService.form.getValue('country') || BRAZIL.includes(ContractFormService.form.getValue('country'))
            ? 'real'
            : 'dollar'
        }
        isV2={ContractFormService.isV2}
      />
    );
  }
}

export default observer(ContractFormContainer);
